import { RestService } from "./RestService";

export class MovieAdviceService extends RestService {
  constructor() {
    super("/api/v1/movie_advices");
  }
}
